<template>
  <dara-single-content-layout container-size="md">
    <template #content>
      <div class="d-flex align-items--center direction--column">
        <dara-icon size="xxl" icon="files" />
        <dara-header>{{ $t('track-not-found') }}</dara-header>
        <dara-p>
          {{ $t('we-could-not-find-the-track-you-are-looking-for') }}
        </dara-p>
        <br>
        <dara-button theme="primary" @click="goToBasePage()">
          {{ $t('return-to-page') }}
        </dara-button>
      </div>
    </template>
  </dara-single-content-layout>
</template>

<script>
import { goToBasePage } from '@/router/route.service';
import DaraSingleContentLayout from '@/layouts/SingleContentLayout.vue';

export default {
  name: 'DaraTrackNotFoundPage',
  components: {
    DaraSingleContentLayout,
  },
  methods: {
    goToBasePage,
  },
};
</script>
